import { getApiUrlForEnv, getPanelUrlForEnv } from './getenvurl'

export { getApiUrlForEnv, getPanelUrlForEnv }
